import {customCheckbox} from "./custom-checkbox";

function loadClass(){
  jQuery('div.mktoFieldDescriptor').parent('.mktoFormRow').each(function(idx){
    this.id = idx;
    if(!jQuery(this).hasClass('mkto-field')){
      jQuery(this).addClass('mkto-field');
    } 
  });
}

export function marketoForm() {
  let marketo = window.MktoForms2;

  if (marketo !== undefined) {   

    MktoForms2.whenReady(function (form) {
      let formId = form.getId();

      jcf.setOptions("Select", {
        wrapNative: false,
        maxVisibleItems: 9
      });
      jcf.replaceAll();
      $('.mktoForm select').on('change', function () {
        jcf.replaceAll();
      });

      customCheckbox(formId);
      loadClass();

      jQuery('#mktoForm_' + formId + ' select').change(function () {

        customCheckbox(formId);
        loadClass();

        jQuery('#mktoForm_' + formId + ' select').on('change', function () {
          customCheckbox(formId);
          loadClass();
        });

      });

      if (document.getElementById("mktoForms2ThemeStyle")) {
        document.getElementById("mktoForms2ThemeStyle").remove();
      }

    });
  }
}


// WEBPACK FOOTER //
// ./assets/js/modules/marketo-form.js